import * as stateManagement from '#packages/stateManagement';
import { BasePublicApi } from '#packages/apilib';
import type { BranchesManagerScope } from './branchesManagerScope';
import experiment from 'experiment';

async function initBranchesData(scope: BranchesManagerScope): Promise<void> {
  const { editorAPI } = scope;
  const branchId = editorAPI.dsRead.generalInfo.getBranchId();

  if (branchId) {
    await editorAPI.store.dispatch(
      stateManagement.branches.actions.assignBranchesData(),
    );
  }
}

export class BranchesManagerApi extends BasePublicApi<BranchesManagerScope> {
  initBranchesData = this.bindScope(initBranchesData);
}

export const initializeBranches = async (
  scope: BranchesManagerScope,
): Promise<void> => {
  try {
    const isExperimentOpen = experiment.isOpen(
      'specs.responsive-editor.classicToStudio',
    );

    if (!isExperimentOpen) {
      return;
    }
    await initBranchesData(scope);
  } catch (error: unknown) {
    console.warn(
      'Branches Manager: Failed to initialize branches data:',
      error,
    );
  }
};
